import { GridColumnConfig } from "../../../../../../../models/gridCoumnConfig";

export const planMapColumns: GridColumnConfig[] = [
  {
    title: 'Plan (File) Name',
    field: 'planName',
    filter: 'text',
    searchable: true,
    width:'200px'
  },
  {
    title: 'File Type',
    field: 'planFileTypeName',
    filter: 'text',
    searchable: true,
    width:'200px'
  },
  {
    title: 'Customer Name',
    field: 'customerName',
    filter: 'text',
    searchable: true,
    width:'200px'
  },
  {
    title: 'Office(s)',
    field: 'officeName',
    filter: 'text',
    searchable: true,
    width:'200px'
  },
  {
    title: 'Associated Plan (File) Name',
    field: 'associatedPlanName',
    filter: 'text',
    searchable: true,
    width:'230px'
  },
  {
    title: 'Private Provider Plan Review',
    field: 'planReview',
    filter: 'text',
    width:'230px'
  },
  {
    title: 'Energy Modelling / Rebate Processing',
    field: 'rebateProcess',
    filter: 'text',
    width:'290px'
  },
];
